import { Box, Typography } from "@mui/material";
import React from "react";
import FileUploadButton from "./FileUploadButton";
import Lottie from "react-lottie";
import animationData from "../../../../lotties/no_file_uploaded_yet.json";
import { defaultLottieOptions } from "../../../../utils/utils";

function EmptyFilesScreen() {
  return (
    <Box
      flex={1}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}>
      <Lottie
        options={{ ...defaultLottieOptions, animationData: animationData }}
        height={192}
        width={192}
      />
      <Typography variant="h6">No files uploaded yet!</Typography>
      <Box mb={1} />
      <Typography>Upload a file to get started.</Typography>
      <Box mb={3} />
      <FileUploadButton />
    </Box>
  );
}

export default EmptyFilesScreen;
